export default __webpack_public_path__ + "static/media/arrow-right-ffffff.7672b0a4.svg";